import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-db524de8"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "participantsPanelContainer" }
const _hoisted_2 = { class: "participantsPanel" }
const _hoisted_3 = { class: "participantsScrollContainer" }
const _hoisted_4 = { class: "participants" }

import { RoomParticipant } from "@/types/call";
import CallParticipant from "../CallParticipant/CallParticipant.vue";

interface Props {
  localParticipant: RoomParticipant | null;
  participants: RoomParticipant[];
}

export default /*#__PURE__*/_defineComponent({
  __name: 'CallParticipantsPanel',
  props: {
    localParticipant: { default: null },
    participants: { default: () => [] }
  },
  setup(__props: any) {



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      (_ctx.localParticipant?.user.id)
        ? (_openBlock(), _createBlock(CallParticipant, {
            key: 0,
            "room-participant": _ctx.localParticipant
          }, null, 8, ["room-participant"]))
        : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.participants, (participant) => {
            return (_openBlock(), _createElementBlock(_Fragment, null, [
              (participant?.participant)
                ? (_openBlock(), _createBlock(CallParticipant, {
                    key: participant.user.id,
                    "room-participant": participant
                  }, null, 8, ["room-participant"]))
                : _createCommentVNode("", true)
            ], 64))
          }), 256))
        ])
      ])
    ])
  ]))
}
}

})